module.exports = "pegasus/assets/theme6/twitter-icon-1.png";